import deploymentService from '@/services/amio/deployment.service'
import AmioHttpService from '@/services/amio/amio-http.service'
import { CHANNEL_TYPE_ICON_MAP } from '@/utils/channel.constants'

class ChannelService extends AmioHttpService {
  async channelList(botId) {
    try {
      const deployments = await deploymentService.list(botId)
      return deployments.map(({ channel }) => {
        return {
          ...channel, icon: CHANNEL_TYPE_ICON_MAP[channel.type]
        }
      })
    } catch (err) {
      throw this.handleError(err)
    }
  }
}

export default new ChannelService()
